import { useTranslation } from "react-i18next";
import { ArrowDownUp, LogOut } from "lucide-react";

// Sortable table inside the detail dialog: sticky header, its own scroll area, zebra rows.
export const DetailTable = ({ detail, state, onKill }) => {
  const { t } = useTranslation();
  const { rows, sort, toggleSort } = state;
  const ids = detail.ids;

  return (
    <div className="min-h-0 flex-1 overflow-auto rounded-2xl shadow-neu-in" dir="ltr">
      <table className="w-full border-separate border-spacing-0 text-start font-mono text-xs">
        <thead className="sticky top-0 z-10 bg-background/95 backdrop-blur">
          <tr className="text-muted-foreground">
            {detail.columns.map((c, i) => (
              <th
                key={c}
                onClick={() => toggleSort(i)}
                data-testid={`detail-sort-${i}`}
                className={`cursor-pointer select-none border-b border-border/60 px-3 py-2.5 text-start text-[11px] font-black hover:text-primary ${
                  sort.index === i ? "text-primary" : ""
                }`}
              >
                <span className="inline-flex items-center gap-1">
                  {c} <ArrowDownUp className="h-3 w-3" />
                </span>
              </th>
            ))}
            {ids ? <th className="border-b border-border/60 px-3 py-2.5" /> : null}
          </tr>
        </thead>
        <tbody data-testid="detail-rows">
          {rows.map((row, i) => (
            <tr key={i} className={i % 2 ? "bg-foreground/[0.03]" : ""}>
              {row.map((cell, j) => (
                <td
                  key={j}
                  className={`px-3 py-2 align-middle ${
                    j === 0 ? "break-all font-bold" : "whitespace-nowrap text-end text-muted-foreground"
                  }`}
                >
                  {cell}
                </td>
              ))}
              {ids ? (
                <td className="px-3 py-2">
                  <button
                    type="button"
                    data-testid={`detail-kill-${i}`}
                    onClick={() => onKill(ids[detail.rows.indexOf(row)])}
                    className="flex items-center gap-1 rounded-xl px-2 py-1 text-[10px] font-bold text-destructive shadow-neu-sm hover:shadow-neu-in"
                  >
                    <LogOut className="h-3 w-3" /> {t("system.killSession")}
                  </button>
                </td>
              ) : null}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};
